import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AsyncResponse } from "abweb/dto/async/AsyncResponse";
import { PollResponse } from "abweb/dto/async/PollResponse";
export class RPCPollingService {
  constructor(rpcService) {
    _defineProperty(this, "rpcService", void 0);
    this.rpcService = rpcService;
  }
  startTask(appRelativeUrl, params, init) {
    // this.rpcService.incrementOutstandingRequestCount();
    return this.rpcService.invokeRetObj(appRelativeUrl, params, AsyncResponse, init);
  }
  cancelTask(taskId) {
    return this.rpcService.invokeVoid("/api/abweb/polling/cancel/" + taskId, null);
  }
  poll(pingOnly) {
    return this.rpcService.invokeRetObj("/api/abweb/polling/poll?pingOnly=" + pingOnly, null, PollResponse, undefined, false);
  }
  setPollTimeout(handler, delay) {
    setTimeout(handler, delay);
  }
}
//# sourceMappingURL=RPCPollingService.js.map
